import React from "react";
import { Button, Modal } from "react-bootstrap";
import InputField from "../../jsx/components/fields/inputField";
import WhiteGreenButton from "../../jsx/components/button/whiteGreenButton";

const DrawTextModal = ({
    onClickAccept,
    onClickReject,
    modalStatus,
    yesBtnTxt = 'Yes',
    noBtnTxt = "No",
    value,
    onChange,
    errorOccured,
    errorMeesage,
    labelName,
    placeholderName,
}) => {
    return (
        <Modal show={modalStatus} style={{}}>

            <div style={{padding: "30px",}}>
                <InputField
                    labelName={labelName}
                    placeholderName={placeholderName}
                    value={value}
                    onChange={onChange}
                    errorOccured={errorOccured}
                    errorMeesage={errorMeesage}
                />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}>

                    <WhiteGreenButton
                        onClick={onClickReject}
                        buttonName={noBtnTxt}
                        className={'white-background-btn'}
                        variant={'primary'}
                    />

                    <WhiteGreenButton
                        onClick={onClickAccept}
                        buttonName={yesBtnTxt}
                        className={'green-background-btn'}
                        variant={'primary'}
                    />
                </div>

            </div>
        </Modal>

    );
};

export default DrawTextModal;
